var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19936_13122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4159 30.8853C7.74767 30.8853 5.37426 29.1769 4.51242 26.6335L4.45413 26.4419C4.25088 25.7683 4.16574 25.2019 4.16574 24.6352V13.2714L0.122364 26.7684C-0.397668 28.7536 0.787358 30.8118 2.77563 31.3602L28.548 38.2622C28.8697 38.3455 29.1914 38.3855 29.5082 38.3855C31.168 38.3855 32.6848 37.2838 33.1099 35.6602L34.6114 30.8853H10.4159Z",
    fill: "#E4E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 5.46774V24.6351C40 26.7018 38.3166 28.3852 36.2499 28.3852H10.4159C10.2492 28.3852 10.0826 28.3684 9.93245 28.3516C8.18253 28.1352 6.81592 26.7018 6.68256 24.9351C6.66577 24.835 6.66577 24.7349 6.66577 24.6351V5.46774C6.66577 3.40104 8.34916 1.71765 10.4159 1.71765H36.2499C38.3166 1.71765 40 3.40104 40 5.46774Z",
    fill: "#E4E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3326 10.0513C18.3326 11.8922 16.8403 13.3848 14.9994 13.3848C13.1582 13.3848 11.6659 11.8922 11.6659 10.0513C11.6659 8.21042 13.1582 6.71777 14.9994 6.71777C16.8403 6.71777 18.3326 8.21042 18.3326 10.0513Z",
    fill: "#FFB521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 19.9515V24.6351C40.0001 26.7018 38.3167 28.3852 36.25 28.3852H10.4159C10.2493 28.3852 10.0826 28.3685 9.9325 28.3517L27.0997 11.1848C28.2331 10.0514 30.0996 10.0514 31.2331 11.1848L40.0001 19.9515Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 28.3852H10.4159C10.2493 28.3852 10.0827 28.3684 9.93251 28.3517C8.18259 28.1353 6.81598 26.7018 6.68262 24.9351L14.5994 17.0181C15.7328 15.8849 17.5993 15.8849 18.7328 17.0181L30.0996 28.3852Z",
    fill: "#45A4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19936_13122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSvg);
export default __webpack_public_path__ + "static/media/ImageSvg.9b2981df74275b5b184b27cfef3bcf90.svg";
export { ForwardRef as ReactComponent };